var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"1em"}},[_c('input',{ref:"upload",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":true},on:{"change":_vm.onChange}}),_c('a-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v("上传")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }